// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"532":"e32c2387","652":"e32c2387"}[chunkId] + ".chunk.css";
};